export const selectTheme = [
    {
        id: 1,
        name: 'выберите тему'
    },
    {
        id: 2,
        name: 'приобрести продукцию'
    },
    {
        id: 3,
        name: 'получить консультацию'
    },
    {
        id: 4,
        name: 'стать партнером'
    },
    {
        id: 5,
        name: 'поставщикам'
    },
    {
        id: 6,
        name: 'другое'
    }
]

export const selectDirection = [
    {
        id: 1,
        name: 'выберите направление'
    },
    {
        id: 2,
        name: 'яичное птицеводство'
    },
    {
        id: 3,
        name: 'индейководство'
    },
    {
        id: 4,
        name: 'бройлерное птицеводство'
    },
    {
        id: 5,
        name: 'свиноводстово'
    },
    {
        id: 6,
        name: 'КРС'
    },
    {
        id: 7,
        name: 'другие животные'
    },
    {
        id: 8,
        name: 'сырьевые компоненты'
    },
    
    {
        id: 9,
        name: 'Экспорт'
    },
    {
        id: 10,
        name: 'hr'
    },
]

export const selectOrganization = [
    {
        id: 1,
        name: 'тип организации'
    },
    {
        id: 2,
        name: 'Агропредприятие'
    },
    {
        id: 3,
        name: 'ИП или КФХ'
    },
    {
        id: 4,
        name: 'Частное лицо'
    },
    {
        id: 5,
        name: 'Другое'
    }
]

export const inputItems = [
    {
        label: 'как к вам обращаться',
        name: 'name',
        placeholder: 'Имя',
        isRequired: true,
        minLength: 3,
        validate: (value) => {
            const words = value.trim().split(/\s+/);
            return (
                words.length === 2 &&
                words.every((word) => word.length >= 2)
            );
        },
    },
    {
        label: 'электронная почта',
        name: 'mail',
        placeholder: 'test@mail.ru',
        isRequired: true,
        minLength: 10,
        pattern: {
            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
            message: 'Invalid email address',
        },
    },
    {
        label: 'телефон',
        name: 'phone',
        placeholder: '+7 900 000-00-00',
        isRequired: false,
        minLength: 16,
        validate: (value) => {
            const words = value.trim().split(/\s+/);
            return (
                words.length === 2 &&
                words.every((word) => word.length >= 3)
            )
        }
    },
]

export const selectRegion = ['Россия'
    , 'Англия'
    , 'Хорватия'
    , 'Венгрия'
    , 'Россия'
    , 'Англия'
    , 'Хорватия'
    , 'Венгрия'

]

export const selectAmountOfHeads = [
    {
        id: 1,
        name: 'выберите количество'
    },
    {
        id: 2,
        name: '0-200'
    },
    {
        id: 3,
        name: '200-500'
    },
    {
        id: 4,
        name: '500-1500'
    },
    {
        id: 5,
        name: '1500-5000'
    },
    {
        id: 6,
        name: '5000-15000'
    },
    {
        id: 7,
        name: '15000-50000'
    },
    {
        id: 8,
        name: '50000-300000'
    },
    {
        id: 9,
        name: '300000-1 млн'
    },
    {
        id: 10,
        name: 'более 1 млн '
    }
]

export const labelsList = {
    topic: 'тема обращения',
    direction: 'продукция',
    organizationType: 'вы представляете',
    amountOfHeads: 'количество голов'
}